import React from 'react';
import Loader from 'views/admin/default/Loader';

const Show = ({ when, children }) => {
   return when ? children : <Loader />;
};

export default Show;
